import Header from "components/menus/Header/Header.component";
import SEO from "components/data-display/SEO/SEO.component";
import GoogleAd from "features/main/components/GoogleAd/GoogleAd.component";
import PaymentCalculator from "features/payment-calculator/PaymentCalculator.component";
import useQueryParamsState from "hooks/useQueryParamsState.hook";
import CalculatorFAQ from "features/payment-calculator/components/CalculatorFAQ/CalculatorFAQ.component";

import Typography from "@mui/material/Typography";
import TalkToVEChip from "features/main/pages/VDP/components/TalkToVEChip/TalkToVEChip.component";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    margin: "16px 16px 0px 16px",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      alignItems: "center",
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 110, // give space because of bottom bar
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      fontWeight: 600,
    },
  },
  disclaimer: {
    fontSize: 18,
    marginTop: 16,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
  },
  paymentCalculator: {
    width: "fit-content",
    padding: "16px",
  },
  googleAd: {
    // vertical ads
    minWidth: "336px", // these values are based on the top performing
    minHeight: "600px", // ad sizes according to google adsense
    [theme.breakpoints.down("lg")]: {
      // desktop banners / leaderboard ads
      minWidth: "728px",
      minHeight: "320px",
    },
    [theme.breakpoints.down("md")]: {
      // tablet sized ads
      minWidth: "320px",
      minHeight: "320px",
    },
    [theme.breakpoints.down("sm")]: {
      // mobile sized ads
      minWidth: "320px", // for smallest screen size (not including samsung fold)
      minHeight: "280px",
    },
  },
}));

export default function PaymentCalculatorPage() {
  const classes = useStyles();
  const [price, setPrice] = useQueryParamsState("price", "5000");
  const [downPayment, setDownPayment] = useQueryParamsState("downPayment", "0");
  const [term, setTerm] = useQueryParamsState("term", 60);
  const [apr, setApr] = useQueryParamsState("apr", 7.99);
  const [province, setProvince] = useQueryParamsState("province", "bc");
  const [activeTab, setActiveTab] = useQueryParamsState("activeTab", "finance");
  const [residual, setResidual] = useQueryParamsState("residual", 0);
  const [additionalFees, setAdditionalFees] = useQueryParamsState(
    "additionalFees",
    0,
  );

  const sharedStates = {
    price,
    setPrice,
    downPayment,
    setDownPayment,
    term,
    setTerm,
    apr,
    setApr,
    province,
    setProvince,
    activeTab,
    setActiveTab,
    residual,
    setResidual,
    additionalFees,
    setAdditionalFees,
  };

  return (
    <>
      <SEO
        title="Payment Calculator | VINN"
        description="Payment Calculator."
        url="https://www.vinnauto.com/payment-calculator"
      />
      <Header />
      <div className={classes.root}>
        <div className={classes.googleAd}>
          <GoogleAd slotId="5507126947" loadAdsScript />
        </div>
        <div className={classes.paymentCalculator}>
          <div className={classes.header}>
            <Typography className={classes.title}>
              Calculate your payments
            </Typography>
            <TalkToVEChip color="secondary" title="Help" quantity={3} />
          </div>
          <Typography className={classes.disclaimer}>
            This calculator is a research tool and does not represent a
            dealership quote or offer.
          </Typography>
          <PaymentCalculator sharedStates={sharedStates} />
          <CalculatorFAQ />
        </div>
        <div className={classes.googleAd}>
          <GoogleAd slotId="9189766757" />
        </div>
      </div>
    </>
  );
}
